import { makeStyles, TextField } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import React from "react";

const useStyles = makeStyles({
  label: {
    "& .MuiInputBase-input": {
      fontWeight: "bold"
    },
    "& .MuiFormLabel-root": {
      color: "#ffffff"
    },
    "& .MuiInputBase-root": {
      color: "#ffffff"
    },
    "& .MuiSelect-icon": {
      color: "#ffffff"
    },
    "& .MuiIconButton-label": {
      color: "#ffffff"
    },
  },
});

const MySelectCheckbox = (props) => {
  const { handleChange, value, label, style, datas, size, disabled } = props;
  const classes = useStyles();

  return (
    <>
      {
        props.disabled &&
        <Autocomplete
          className={classes.label}
          multiple
          options={datas}
          getOptionLabel={(option) => option}
          value={value}
          filterSelectedOptions
          style={style}
          disableCloseOnSelect={true}
          size={size}
          color="secondary"
          renderInput={(params) => (
            <TextField
              {...params}
              label={label}
              // color="secondary"
              style={{ backgroundColor: '#8ca0a8' }}
            />
          )}
        />
      }
      {
        !props.disabled &&
        <Autocomplete
          className={classes.label}
          multiple
          options={datas}
          getOptionLabel={(option) => option}
          value={value}
          filterSelectedOptions
          style={style}
          disableCloseOnSelect={true}
          size={size}
          onChange={(e, v) => handleChange(e, v)}
          color="secondary"
          renderInput={(params) => (
            <TextField
              {...params}
              label={label}
              color="secondary"
            />
          )}
        />

      }

    </>
  );

};

export default MySelectCheckbox;